module.exports = __webpack_public_path__ + "static/media/logo-dark.e85d49ea.svg";